// extracted by mini-css-extract-plugin
export default {"banner":"styles__banner--ecde4b52c785535e5fde"};